var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.clazz,style:(_vm.svgStyle),attrs:{"version":"1.1","viewBox":_vm.box},domProps:{"innerHTML":_vm._s(_vm.markup)},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }